<template>
  <w-datepicker :title="title" :model="$schema.date" @input="updateValue" />
</template>

<script>
import moment from 'moment';

import { formMixin } from '@/mixins/form';

const schema = {
  properties: {
    date: { type: 'string', format: 'date' }
  }
};

// @vuese
// Datepicker bez schemy
// @group Form
export default {
  mixins: [formMixin],
  schema,
  props: {
    // Wartość
    value: { type: [Date, String] },
    // Wyświetlany tytuł
    title: { type: String, default: '' },
    // Opcje: {
    //   manipulateDate?: Record<string, any[]>
    // }
    options: { type: Object, required: false }
  },
  data() {
    return { model: {} };
  },
  watch: {
    value(newValue) {
      this.setSchemaData(newValue);
    }
  },
  mounted() {
    if (this.value && typeof this.value === 'string') {
      this.$emit('input', new Date(this.value));
    } else {
      this.setSchemaData(this.value);
    }
  },
  methods: {
    // @vuese
    // Ustawia wartość w schemie i tym samym na widoku
    setSchemaData(newValue) {
      if (!newValue) {
        this.$schema.date.$setData(null);
        return;
      }

      let value = moment(newValue);

      if (this.options?.manipulateDate && typeof this.options.manipulateDate === 'object') {
        Object.keys(this.options.manipulateDate).forEach(key => {
          const manipulationData = this.options.manipulateDate[key];
          value = value[key](...manipulationData.map(param => (typeof param === 'number' ? -param : param)));
        });
      }

      value = value.format('YYYY-MM-DD');

      if (value === this.$schema.date.$model) {
        return;
      }

      this.$schema.date.$setData(value);
    },

    // @vuese
    // Ustawia wartość modelu przez emit eventu `input`
    updateValue(newValue) {
      let value = newValue && moment(newValue, 'DD.MM.YYYY');
      if (!value) {
        this.$emit('input', value);
        return;
      }

      if (this.options?.manipulateDate && typeof this.options.manipulateDate === 'object') {
        Object.keys(this.options.manipulateDate).forEach(key => {
          const manipulationData = this.options.manipulateDate[key];
          value = value[key](...manipulationData);
        });
      }

      this.$emit('input', value.toDate());
    }
  }
};
</script>
